import React from "react";
import { modules } from "../data/content";
import { eyebrow, h2, shell } from "../utils/styles";
export function Program() {
  return <section id="programa" className={`${shell} pb-[60px] sm:pb-[95px]`} data-id="element-139" data-mp="ezqj1g9wqznk">
      <div className="mb-7 sm:mb-[35px] sm:flex sm:items-end sm:justify-between sm:gap-[30px]" data-id="element-140" data-mp="a39x8sq6kxdn">
        <div data-id="element-141" data-mp="546szai0yv6q">
          <p className={eyebrow} data-id="element-142" data-mp="54gmv966xmhp">El programa</p>
          <h2 className={`${h2} mb-0`} data-id="element-143" data-mp="12qvyhubxrpxc">La formación que acompaña tu proceso</h2>
        </div>
        <p className="mt-5 max-w-[300px] text-xs leading-[1.75] text-muted sm:mb-[5px] sm:mt-0" data-id="element-144" data-mp="xrt7hdssjk8d">
          8 módulos en Skool, del primer paso a tus primeras campañas.
        </p>
      </div>
      <ol className="grid grid-cols-2 border-l border-t border-line-soft lg:grid-cols-4" data-id="element-145" data-mp="sukml5g9d23f">
        {modules.map((m, i) => <li key={m.title} className="border-b border-r border-line-soft px-4 py-[22px] sm:px-[23px] sm:py-[25px]" data-id="element-146" data-mp="3djgq04725a7n" data-mpi={i}>
            <small className="text-[10px] uppercase tracking-[1.5px] text-[#a0b089]" data-id="element-147" data-mp="39h3u07i44qo2">
              Módulo {String(i + 1).padStart(2, "0")}
            </small>
            <h3 className="mb-3 mt-[17px] min-h-[38px] font-display text-sm font-semibold leading-[1.35] tracking-[-0.5px] sm:mt-5 sm:min-h-[40px] sm:text-[15px]" data-id="element-148" data-mp="1tlhxuut2cko5">
              {m.title}
            </h3>
            <p className="text-[11px] leading-[1.75] text-muted" data-id="element-149" data-mp="1jnbwceb65gjt">{m.description}</p>
          </li>)}
      </ol>
    </section>;
}